import React from 'react';
import styled from 'styled-components';
import { KatButton, KatIcon } from '@amzn/katal-react';
import Spacer from 'src/components/Layout/Spacer';
import { ReadMore } from 'src/components/ReadMore';

const DescriptionBody = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.Tarpon};
  text-align: center;
`;

const ReportingCard = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.2rem;
  max-width: max(40%, 10rem);
`;

const Header = styled.div`
  font-size: ${({ theme }) => theme.fontSize.m};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const ButtonContainer = styled.div`
  padding-top: 0.1rem;
  display: flex;
  gap: 0.5rem;
`;

export interface IKeyOfferingItem {
  hidden?: boolean;
  iconName: KatIcon.Name;
  header: string;
  description?: string;
  primaryButtonLabel?: string;
  primaryButtonAction?: () => void;
  secondaryButtonlabel?: string;
  secondaryButtonAction?: () => void;
}

const KeyOfferingItem: React.FC<IKeyOfferingItem> = (params) => {
  return (
    <ReportingCard>
      <KatIcon
        data-testid="KatIconLarge"
        name={params.iconName}
        size="large"
      ></KatIcon>
      <Header>{params.header}</Header>
      <DescriptionBody>
        <ReadMore text={params.description!} />
      </DescriptionBody>
      {params.primaryButtonAction && (
        <ButtonContainer>
          {params.secondaryButtonAction && (
            <KatButton
              data-testid="KatActionButton"
              variant="secondary"
              size="small"
              label={params.secondaryButtonlabel}
              onClick={params.secondaryButtonAction}
            ></KatButton>
          )}
          <KatButton
            data-testid="KatActionButton"
            variant="primary"
            size="small"
            label={params.primaryButtonLabel}
            onClick={params.primaryButtonAction}
          ></KatButton>
        </ButtonContainer>
      )}
    </ReportingCard>
  );
};

export { KeyOfferingItem };
